<tg-bulk-edit-progress-overlay
	[failed]="failedCount"
	[mode]="mode"
	[percent]="loadingPercent"
	[phase]="loadingPhase"
></tg-bulk-edit-progress-overlay>
<div matDialogTitle>
	<div>{{ titleKey | translate: { count: total } }}</div>
</div>
<mat-dialog-content class="bulk-operation-progress-dialog__content"></mat-dialog-content>
